import { render } from "./ProductToWarehouses.vue?vue&type=template&id=c09d4c3c&scoped=true&ts=true"
import script from "./ProductToWarehouses.vue?vue&type=script&lang=ts"
export * from "./ProductToWarehouses.vue?vue&type=script&lang=ts"

import "./ProductToWarehouses.vue?vue&type=style&index=0&id=c09d4c3c&lang=scss&scoped=true"

import exportComponent from "D:\\YellowBeardProject\\caffeine\\caffeineshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c09d4c3c"]])

export default __exports__